import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Contactos} from '../../contactos/contactos';
import {Modal} from '@shared/components/common/modal/modal';

@Component({
  selector: 'app-seleccionar-contacto-propuesta',
  imports: [
    Contactos,
    Modal
  ],
  templateUrl: './seleccionar-contacto-propuesta.html',
  styles: ``
})
export class SeleccionarContactoPropuesta {
  private dialogRef = inject(MatDialogRef<SeleccionarContactoPropuesta>);
  private data = inject<{ idProspecto: number }>(MAT_DIALOG_DATA);

  idProspecto = this.data.idProspecto;

  selectContacto(idContacto: number): void {
    this.dialogRef.close(idContacto);
  }

  close(): void {
    this.dialogRef.close();
  }
}
